// this is the entry point for Public Upload page and also a routes file
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "./Navigation";
import UploadList from "./UploadList";
import UploadForm from "./UploadForm";
import UploadDetail from "./UploadDetail";
import UploadsByCategory from "./UploadsByCategory";

export default function PublicUpload() {
  return (
    <div className="container mx-auto py-6 px-4 max-w-7xl">
      <Navigation />
      <div className="mt-6">
        <Routes>
          <Route path="/" element={<UploadList />} />
          <Route path="upload/new" element={<UploadForm />} />
          <Route path="upload/:id" element={<UploadDetail />} />
          <Route path="upload/edit/:id" element={<UploadForm />} />
          <Route path="by-category" element={<UploadsByCategory />} />
        </Routes>
      </div>
    </div>
  );
}